








import { Vue, Component } from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import AdminIframe from '@/components/iframe/AdminIframe.vue';



@Component({
  components: {
    PageTitle,
    AdminIframe,
  }
})
export default class RestockSmsSend extends Vue {
  private get remoteSrc() {
    const {mallNo, mallName, recipients, type, optionName, optionValue, productName, restockNos} = this.$route.query;
    return `${process.env.VUE_APP_ADMIN_REMOTE_URL}/popup/sms-send?serviceType=PREMIUM&mallNo=${mallNo}&mallName=${mallName}&recipients=${recipients}&type=${type}&productName=${productName}&optionName=${optionName}&optionValue=${optionValue}&restockNos=${restockNos}`;
  }

}

